import type WebApiClient from "../../api/WebApiClient.js";
import { type IAppState } from "../reducer.js";
import { createReducer } from "../redux-utils.js";
import { createErrorHandler } from "@/app-utils/errors.ts";
import { type Sequence } from "@/graphql.ts";
import { LOAD_SEQUENCE_FAILURE, LOAD_SEQUENCE_REQUEST, LOAD_SEQUENCE_SUCCESS } from "@/redux/action-types.ts";

/**
 * State definition
 */
export interface ISequenceState {
  sequence?: Sequence;
  isLoading: boolean;
}

const initialState: ISequenceState = {
  isLoading: false,
  sequence: null,
};

/**
 * Reducers
 */
export default createReducer(initialState, {
  [LOAD_SEQUENCE_REQUEST]: (state: ISequenceState, _payload: Sequence): ISequenceState => {
    return { ...state, isLoading: true };
  },
  [LOAD_SEQUENCE_SUCCESS]: (state: ISequenceState, payload: Sequence): ISequenceState => {
    return { ...state, isLoading: false, sequence: payload };
  },
  [LOAD_SEQUENCE_FAILURE]: (state: ISequenceState, _payload): ISequenceState => {
    return { ...state, isLoading: false, sequence: null };
  },
});

/**
 * Action creators
 */
export function shouldLoadSequence(sequenceId: number) {
  return (dispatch, getState, webApiClient: WebApiClient): Promise<Sequence> => {
    const state: IAppState = getState();

    // fetch the sequence only if no loading is currently in progress and sequence is either absent or doesn't match the sequence ID
    if (!state.sequence.isLoading && (!state.sequence.sequence || state.sequence.sequence.id !== sequenceId)) {
      dispatch({ type: LOAD_SEQUENCE_REQUEST });

      return webApiClient
        .fetchSequence(sequenceId)
        .then((response: Sequence) => {
          dispatch({
            type: LOAD_SEQUENCE_SUCCESS,
            payload: response,
          });
          return response;
        })
        .catch(
          createErrorHandler(dispatch, {
            actionType: LOAD_SEQUENCE_FAILURE,
            alertTitle: "Fetching of Sequence Failed",
          }),
        );
    }
  };
}
